import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ColumnSection from "./components/ColumnSection";
import ReportSection from "./components/ReportSection";
import DebunkSection from "./components/DebunkSection";
import MethodSection from "./components/MethodSection";
import CriteriaSection from "./components/CriteriaSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ColumnSection />
        <ReportSection />
        <DebunkSection />
        <MethodSection />
        <CriteriaSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}